// extracted by mini-css-extract-plugin
export default {"financeTradesEditorContainer":"_finance-trades-editor_financeTradesEditorContainer__yvPOM"};